import { useSyncExternalStore } from 'react';

let open = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

/** Відкриває або закриває навігатор модулів (стан оболонки, спільний для верхньої панелі, Головної й гарячої клавіші Ctrl/⌘ K). */
export function setNavigatorOpen(next: boolean): void {
  if (open === next) return;
  open = next;
  listeners.forEach((l) => l());
}

/** Ctrl/⌘ K: повторне натискання закриває навігатор (patterns/keyboard). */
export function toggleNavigator(): void {
  setNavigatorOpen(!open);
}

/** Чи відкритий навігатор модулів. */
export function useNavigatorOpen(): boolean {
  return useSyncExternalStore(subscribe, () => open, () => false);
}
